const machine_txt = {
    type: "VA-L01-D2",
    name: "Direct Drive High Speed Lockstitch Sewing Machine With Automatic Thread Trimming",
    description: [
        "Applicable for sewing thin and medium-heavy materials, such as sweatshirts, shirts,jackets, suit trousers,T-shirts, skirts, jeans, and outerwear.",
        "The head features an oil-free thread take-up lever and needle bar design,which prevents fabric contamination caused by oil stains;the upper thread tension is controlled by an electromagnet,and the system automatically adjusts the thread tension according to the thickness of the sewing material.",
        "With the improved oil supply and return system,the forward and backward tilt of the feed dog can be freely adjusted,minimizing wrinkling and errors between upper and lower sewing materials. The new,simple and reliable presser foot lifting structuregreatly reduces the failure rate, and is convenient and flexible to operate.",
        "The stitch length for forward and reverse feeding is adjustable;the innovative structure ensures consistent stitching and smooth operation when sewing in forward or reverse directions."
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/2/machine_img/1.jpg",
        "/assets/machine/2/machine_img/2.jpg",
        "/assets/machine/2/machine_img/3.jpg",
        "/assets/machine/2/machine_img/4.jpg",
    ],
    machine_other_img:[
        "/assets/machine/2/machine_other/1.png",
    ]
}
export default {machine_txt}